import { FC, PropsWithChildren } from 'react';
import './main.styles.scss';

export const Main: FC<PropsWithChildren> = (props) => (
  <main className="main">
    {props.children}
  </main>
);
